import React from 'react';
import { NavLink } from 'react-router-dom';

import Expandable from 'components/global/application/Expandable';

import './ResourceDropMenu.sass';

interface Props {
    showing: boolean;    // used to toggle display and switch content; component only displays with truthy values
    mouseHovered(event: React.MouseEvent<any>): void;   // methods to update parent so it knows when its safe to clear hoveredItem
    mouseUnHovered(event: React.MouseEvent<any>): void; // ^-- same
}

const ResourceDropMenu: React.StatelessComponent<Props> = (props: Props) => {
    return(
        <Expandable
            direction="vertical"
            maxHeight="22em"
            expanded={props.showing}
            onMouseEnter={props.mouseHovered}
            onMouseLeave={props.mouseUnHovered}
            id="submenu"
            className="ResourceDropMenu-container"
        >
            <div className="Padding-container">
                <div className="Dropmenu-column">
                    <span className="Category-header" ><NavLink exact to="/news">News & Events</NavLink></span>
                    <span className="Category-header" ><NavLink exact to="/vintage-guitars">Vintage Guitar Magazine Articles</NavLink></span>
                    <span className="Category-header" ><NavLink exact to="/newsletter">Newsletters</NavLink></span>
                    <span className="Category-header" ><a href="/archived-inventory">Archived Guitars</a></span>
                </div>
            </div>
        </Expandable>
    );
};

export default ResourceDropMenu;



// WEBPACK FOOTER //
// ./src/components/global/application/nav/ResourceDropMenu.tsx